import { inject } from "mobx-react";
import React from "react";
import { Store } from "../../../../../client/stores";
import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import { FeedResultFragment } from "../../../../core/generated/webapi.g";
import { isLeadsCard } from "../../../../core/lib/guards";
import { placeholderImage } from "../../../../core/lib/image";
import { MagicLink } from "../../../../core/ui";
import { CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import "./CoastCarouselItem.style.scss";

interface CoastCarouselItemProps {
    item: FeedResultFragment;
    store?: Store;
}

export const CoastCarouselItem = inject("store")(({ item, store }: CoastCarouselItemProps) => {
    if (!store) {
        return null;
    }

    const { record: card } = item;
    if (!isLeadsCard(card)) {
        return null;
    }
    const articleUrl = card.link?.urls.web;
    const altText = card.title;
    const thumb = card.image || placeholderImage;
    const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.CAROUSEL, { quality: 80 });

    return (
        <figure className="carousel-item">
            <section className="thumb">
                <MagicLink to={articleUrl} context={articleUrl}>
                    <ResponsiveImage
                        src={imgSrc}
                        srcset={srcset}
                        alt={altText}
                        initialHeight={162}
                        initialWidth={288}
                        lazy={false}
                    />
                </MagicLink>
            </section>
            <figcaption>
                <span className="caption-wrapper">
                    <MagicLink className="card-title" to={articleUrl} context={articleUrl}>
                        {card.title}
                    </MagicLink>
                    <MagicLink className="card-subtitle" to={articleUrl} context={articleUrl}>
                        {card.subtitle}
                    </MagicLink>
                </span>
            </figcaption>
        </figure>
    );
});
